export const GET_UTM_ZONES = '/utm_zone/';
export const GET_UTM_ZONE_QUERY = '/utm_zone/query';
export const POST_UTM_ZONE = '/utm_zone/';
export const GET_UTM_ZONE = '/utm_zone/';
export const PUT_UTM_ZONE = '/utm_zone/';
export const DELETE_UTM_ZONE = '/utm_zone/';
export const CHECK_UTM_ZONE_EXISTS = '/utm_zone/query';
